import GenericService from './genericService';
import axiosInstance from '../utils/axios';

class GeneralsettingService extends GenericService {
    constructor() {
        super('/general-settings', axiosInstance);
    }

    async getSettings() {
        try {
            const response = await axiosInstance.get(`${this.baseUrl}`);
            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }

    async saveSettings(data) {
        try {
            const response = await axiosInstance.post(`${this.baseUrl}`, data);
            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }
}

export default new GeneralsettingService();
